(function () {
  if (window.__sfPdpCustomBooted) return;
  window.__sfPdpCustomBooted = true;

window.sfTriggerKlaviyoBis = function () {
  var root = document.querySelector('[data-sf-pdp-root]');
  var formId = root ? root.getAttribute('data-klaviyo-bis-form-id') : '';

  function openKlaviyoFormById() {
    if (!formId) return false;

    if (window._klOnsite && typeof window._klOnsite.push === 'function') {
      window._klOnsite.push(['openForm', formId]);
      return true;
    }

    return false;
  }

  if (openKlaviyoFormById()) {
    return;
  }

  var attempts = 0;
  var maxAttempts = 30;

  function tryOpen() {
    if (openKlaviyoFormById()) {
      return;
    }

    attempts += 1;

    if (attempts < maxAttempts) {
      window.setTimeout(tryOpen, 250);
    }
  }

  tryOpen();
};
  function norm(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function parseJsonScript(id) {
    if (!id) return null;
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || 'null');
    } catch (e) {
      return null;
    }
  }

  function safeParseJsonAttr(el, attr) {
    if (!el) return '';
    try {
      return JSON.parse(el.getAttribute(attr) || '""');
    } catch (e) {
      return '';
    }
  }

function revealSfPdpRoot(root) {
  if (!root) return;

  root.removeAttribute('data-sf-pdp-loading');
  root.classList.add('is-ready');

  var wizard = root.querySelector('[data-sf-bogo-wizard]');
  if (wizard) {
    wizard.removeAttribute('data-sf-bogo-loading');
    wizard.classList.add('is-ready');
  }
}

function cleanLooxLabels(scope) {
  (scope || document).querySelectorAll('.loox-rating-label').forEach(function (label) {
    if (label.closest('.related-products')) return;
    if (label.closest('.sf-pcard__loox')) return;

    label.textContent = label.textContent.replace(/[()]/g, '').trim();
  });
}
function formatRelatedLooxLabels(scope) {
  (scope || document).querySelectorAll('.related-products .loox-rating-label, .sf-pcard__loox .loox-rating-label').forEach(function (label) {
    var n = (label.textContent || '').replace(/[()]/g, '').trim();

    if (!n) return;

    label.textContent = ' (' + n + ')';
  });
}

  function initDots(root) {
    if (root.__sfDotsInit) return;
    root.__sfDotsInit = true;

    var scrollRaf = 0;

    function bindDots() {
      var viewport = root.querySelector('[data-sf-slider-viewport]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sfrole="slide"]:not([hidden])'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sf-dot]'));
      var dotContainer = root.querySelector('[data-sf-dotnav] .sf-dotnav-inner');

      if (!viewport || !slides.length || !dots.length || !dotContainer) return;

      function getActiveIndex() {
        var scrollLeft = viewport.scrollLeft;
        var best = 0;
        var bestDist = Infinity;

        slides.forEach(function (slide, index) {
          var dist = Math.abs(slide.offsetLeft - scrollLeft);
          if (dist < bestDist) {
            bestDist = dist;
            best = index;
          }
        });

        return clamp(best, 0, slides.length - 1);
      }

      function setActive(index) {
        dots.forEach(function (dot, i) {
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      dotContainer.onclick = function (e) {
        var btn = e.target.closest('[data-sf-dot]');
        if (!btn) return;

        var index = parseInt(btn.getAttribute('data-sf-dot-index'), 10);
        var target = slides[index];
        if (!target) return;

        viewport.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        setActive(index);
      };

      viewport.onscroll = function () {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = 0;
          setActive(getActiveIndex());
        });
      };

      setActive(getActiveIndex());
    }

    root.__sfRebindDots = bindDots;
    bindDots();
  }

  function relayoutMosaic(root) {
    var mosaic = root.querySelector('[data-sf-mosaic]');
    if (!mosaic) return;

    var smallSpan = mosaic.getAttribute('data-small-span') || '';
    var wideSpan = mosaic.getAttribute('data-wide-span') || '';
    var visible = Array.prototype.slice.call(mosaic.querySelectorAll('.sf-mosaic-item[data-sf-media]:not([hidden])'));
    if (!visible.length) return;

    var firstImage = visible.find(function (el) {
      var t = norm(el.getAttribute('data-sf-media-type'));
      return t !== 'video' && t !== 'external_video';
    });

    var firstVideo = visible.find(function (el) {
      var t = norm(el.getAttribute('data-sf-media-type'));
      return t === 'video' || t === 'external_video';
    });

    if (firstImage && firstVideo && firstImage.nextElementSibling !== firstVideo) {
      mosaic.insertBefore(firstVideo, firstImage.nextElementSibling);
    }

    visible = Array.prototype.slice.call(mosaic.querySelectorAll('.sf-mosaic-item[data-sf-media]:not([hidden])'));
    visible.forEach(function (el, i) {
      var makeWide = i >= 2 && (i - 2) % 3 === 0;
      el.classList.toggle('is-wide', makeWide);
      if (makeWide && wideSpan) {
        el.style.setProperty('--sf-span', wideSpan);
      } else if (smallSpan) {
        el.style.setProperty('--sf-span', smallSpan);
      }
    });
  }

  function refreshMobileSlider(root, colorValue) {
    var slider = root.querySelector('[data-sf-slider]');
    if (!slider) return;

    var track = slider.querySelector('.sf-slider-track');
    var dotWrap = slider.querySelector('[data-sf-dotnav] .sf-dotnav-inner');
    var viewport = slider.querySelector('[data-sf-slider-viewport]');
    if (!track || !dotWrap || !viewport) return;

    var color = norm(colorValue);
    var allSlides = Array.prototype.slice.call(track.querySelectorAll('.sf-slide[data-sf-media]'));

    var videos = allSlides.filter(function (el) {
      var t = norm(el.getAttribute('data-sf-media-type'));
      return t === 'video' || t === 'external_video';
    });

    var matchedImages = allSlides.filter(function (el) {
      var t = norm(el.getAttribute('data-sf-media-type'));
      if (t === 'video' || t === 'external_video') return false;
      var alt = norm(el.getAttribute('data-sf-media-alt'));
      return color && alt && alt.indexOf(color) !== -1;
    });

    if (!matchedImages.length) {
      matchedImages = allSlides.filter(function (el) {
        var t = norm(el.getAttribute('data-sf-media-type'));
        return t !== 'video' && t !== 'external_video';
      });
    }

    if (!matchedImages.length) {
      var anyImage = allSlides.find(function (el) {
        var t = norm(el.getAttribute('data-sf-media-type'));
        return t !== 'video' && t !== 'external_video';
      });
      if (anyImage) matchedImages = [anyImage];
    }

    var ordered = [];
    if (matchedImages.length) ordered.push(matchedImages[0]);
    if (videos.length) ordered.push(videos[0]);
    if (matchedImages.length > 1) ordered = ordered.concat(matchedImages.slice(1));
    if (videos.length > 1) ordered = ordered.concat(videos.slice(1));

    if (!ordered.length) ordered = allSlides.slice();

    allSlides.forEach(function (slide) {
      slide.setAttribute('hidden', 'hidden');
    });

    ordered.forEach(function (slide) {
      slide.removeAttribute('hidden');
      track.appendChild(slide);
    });

    dotWrap.innerHTML = '';
    ordered.forEach(function (_, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sf-dot';
      dot.setAttribute('data-sf-dot', '');
      dot.setAttribute('data-sf-dot-index', String(index));
      dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
      dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      dotWrap.appendChild(dot);
    });

    var dotNav = slider.querySelector('[data-sf-dotnav]');
    if (dotNav) dotNav.style.display = ordered.length <= 1 ? 'none' : '';

    viewport.scrollTo({ left: 0, behavior: 'auto' });
    if (root.__sfRebindDots) root.__sfRebindDots();
  }

  function applyColorFilter(root, colorValue) {
    var color = norm(colorValue);
    var items = root.querySelectorAll('[data-sf-media][data-sf-media-type]');
    var matched = 0;

    items.forEach(function (el) {
      var type = norm(el.getAttribute('data-sf-media-type'));
      var alt = norm(el.getAttribute('data-sf-media-alt'));
      var isVideo = type === 'video' || type === 'external_video';
      var show = isVideo || (color && alt && alt.indexOf(color) !== -1);
      if (show) matched++;
      el.toggleAttribute('hidden', !show);
    });

    if (matched === 0) {
      items.forEach(function (el) {
        el.removeAttribute('hidden');
      });
    }

    relayoutMosaic(root);
    refreshMobileSlider(root, colorValue);
  }

  function initGalleryVideo(root) {
    if (root.__sfGalleryVideoInit) return;
    root.__sfGalleryVideoInit = true;

    function setState(btn, video) {
      var isPaused = video.paused || video.ended;
      var pauseIco = btn.querySelector('[data-ico="pause"]');
      var playIco = btn.querySelector('[data-ico="play"]');
      if (pauseIco) pauseIco.style.display = isPaused ? 'none' : '';
      if (playIco) playIco.style.display = isPaused ? '' : 'none';
      btn.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
      var container = btn.closest('[data-sf-media]');
      if (container) container.classList.toggle('is-paused', isPaused);
    }

    function initButton(btn) {
      if (!btn || btn.__sfVideoBound) return;
      btn.__sfVideoBound = true;
      var container = btn.closest('[data-sf-media]') || btn.parentElement;
      var video = container ? container.querySelector('video') : null;
      if (!video) return;

      video.muted = true;
      video.playsInline = true;

      video.addEventListener('play', function () { setState(btn, video); });
      video.addEventListener('pause', function () { setState(btn, video); });
      video.addEventListener('ended', function () { setState(btn, video); });

      try {
        video.play().catch(function () {});
      } catch (e) {}

      setTimeout(function () { setState(btn, video); }, 100);
    }

    root.querySelectorAll('[data-sf-video-toggle]').forEach(initButton);

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sf-video-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var container = btn.closest('[data-sf-media]') || btn.parentElement;
      var video = container ? container.querySelector('video') : null;
      if (!video) return;
      if (video.paused) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }
      setTimeout(function () { setState(btn, video); }, 20);
    }, true);
  }

  function initVideoScrollbar(root) {
    root.querySelectorAll('[data-sf-videos]').forEach(function (videoRoot) {
      if (videoRoot.__sfVideoScrollbarInit) return;
      videoRoot.__sfVideoScrollbarInit = true;

      var scroller = videoRoot.querySelector('[data-sf-vtrack]');
      var bar = videoRoot.querySelector('[data-sf-vscrollbar]');
      var thumb = videoRoot.querySelector('[data-sf-vscrollbar-thumb]');
      if (!scroller || !bar || !thumb) return;

      var raf = null;

      function update() {
        raf = null;
        var scrollW = scroller.scrollWidth;
        var clientW = scroller.clientWidth;
        if (scrollW <= clientW + 1) {
          bar.style.display = 'none';
          return;
        }
        bar.style.display = '';
        var progress = scroller.scrollLeft / Math.max(1, scrollW - clientW);
        var thumbW = Math.max(40, Math.round((clientW / scrollW) * bar.clientWidth));
        thumb.style.width = thumbW + 'px';
        var maxMove = bar.clientWidth - thumbW;
        var x = maxMove * clamp(progress, 0, 1);
        thumb.style.transform = 'translateX(' + x + 'px)';
      }

      function requestUpdate() {
        if (raf) return;
        raf = requestAnimationFrame(update);
      }

      scroller.addEventListener('scroll', requestUpdate, { passive: true });
      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(requestUpdate);
        ro.observe(scroller);
        ro.observe(videoRoot);
      } else {
        window.addEventListener('resize', requestUpdate);
      }
      requestUpdate();
    });
  }

function initBandWidths(root) {
  if (root.__sfBandWidthInit) return;
  root.__sfBandWidthInit = true;

  var t;

  function syncBandButtonWidths() {
    root.querySelectorAll('.sf-bandgrid').forEach(function (grid) {
      var btns = Array.prototype.slice.call(grid.querySelectorAll('.sf-bandbtn'));
      if (!btns.length) return;

      // Reset to natural full width before measuring.
      btns.forEach(function (btn) {
        btn.style.setProperty('--sf-bandbtn-w', 'max-content');
      });

      var max = 0;

      btns.forEach(function (btn) {
        var w = btn.scrollWidth || btn.getBoundingClientRect().width;
        if (w > max) max = w;
      });

      if (!max) return;

      var px = Math.ceil(max) + 'px';

      btns.forEach(function (btn) {
        btn.style.setProperty('--sf-bandbtn-w', px);
      });
    });
  }

  function scheduleSync(delay) {
    window.setTimeout(function () {
      requestAnimationFrame(syncBandButtonWidths);
    }, delay || 0);
  }

  // First-load passes: catches layout, font, and image timing differences.
  scheduleSync(0);
  scheduleSync(100);
  scheduleSync(300);
  scheduleSync(700);

  // Recalculate after fonts load.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      scheduleSync(0);
      scheduleSync(150);
    }).catch(function () {});
  }

  // Recalculate after band icon images load.
  root.querySelectorAll('.sf-bandbtn img').forEach(function (img) {
    if (img.complete) return;

    img.addEventListener('load', function () {
      scheduleSync(0);
      scheduleSync(100);
    }, { once: true });

    img.addEventListener('error', function () {
      scheduleSync(0);
    }, { once: true });
  });

  // Final safety after the full window load.
  window.addEventListener('load', function () {
    scheduleSync(0);
    scheduleSync(150);
  });

  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(syncBandButtonWidths, 150);
  });

  root.addEventListener('change', function (e) {
    if (e.target && e.target.matches('.sf-opt-input')) {
      scheduleSync(0);
      scheduleSync(100);
    }
  });
}
  function initBogoPairs(root) {
    if (!root || root.__sfBogoPairsInit) return;
    root.__sfBogoPairsInit = true;

    var enabled = root.getAttribute('data-sf-enable-free-pair') === 'true';
    if (!enabled) return;

    var ui = root.querySelector('[data-sf-variant-ui]');
    var wizard = root.querySelector('[data-sf-bogo-wizard]');
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var atcBtn = root.querySelector('[data-sf-atc]');
    var atcText = root.querySelector('[data-sf-atc-text]');
    var spinner = root.querySelector('[data-sf-spinner]');
    var variantIdInput = root.querySelector('[data-sf-variant-id]');
    var pair1PropInput = root.querySelector('[data-sf-visible-pair1]');
    var pair2PropInput = root.querySelector('[data-sf-visible-pair2]');
    var priceEl = root.querySelector('[data-sf-price]');
var compareEl = root.querySelector('[data-sf-compare]');
var saveWrap = root.querySelector('[data-sf-save-wrap]');
var saveText = root.querySelector('[data-sf-save-text]');
var savePill = root.querySelector('[data-sf-save-pill]');
var priceWrap = root.querySelector('[data-sf-price-wrap]');
var moneyFormat = priceWrap
  ? (priceWrap.getAttribute('data-money-format') || root.getAttribute('data-money-format') || '{{amount}}')
  : (root.getAttribute('data-money-format') || '{{amount}}');

var presentPayload = parseJsonScript(root.getAttribute('data-presentment-id')) || {};
var presentById = {};
(presentPayload.variants || []).forEach(function (row) {
  presentById[String(row.id)] = row;
});

    if (!ui || !wizard || !form || !atcBtn) return;

    var paidVariants = parseJsonScript(root.getAttribute('data-variants-id')) || [];
    var freeVariants = parseJsonScript(root.getAttribute('data-free-pair-variants-id')) || [];
    var pair2Variants = freeVariants.length ? freeVariants : paidVariants;
    var usingExternalFreePairProduct = freeVariants.length > 0;

    var colorIndex = ui.hasAttribute('data-color-index') ? parseInt(ui.getAttribute('data-color-index'), 10) : -1;
    var sizeIndex = ui.hasAttribute('data-size-index') ? parseInt(ui.getAttribute('data-size-index'), 10) : -1;
    var bandIndex = ui.hasAttribute('data-band-index') ? parseInt(ui.getAttribute('data-band-index'), 10) : -1;

    if (colorIndex < 0 || sizeIndex < 0 || bandIndex < 0) return;

    var activeStep = 1;
    var hasVisitedStep2 = false;
    var isSubmittingBundle = false;

    var stepLabel = root.querySelector('[data-sf-step-label]');
    var stepProgress = root.querySelector('[data-sf-step-progress]');
    var stepLastDot = root.querySelector('[data-sf-step-last-dot]');
    var stepCards = Array.prototype.slice.call(root.querySelectorAll('[data-sf-step-card]'));
    var stepPanels = Array.prototype.slice.call(root.querySelectorAll('[data-sf-step-panel]'));

    var pair1BandSlot = root.querySelector('[data-sf-pair1-band-slot]');
    var pair2BandSlot = root.querySelector('[data-sf-pair2-band-slot]');
    var masterBands = root.querySelector('[data-sf-master-bands]');
    var masterBandsShell = masterBands ? masterBands.closest('.sf-block') : null;

    var pair1NotifyRow = root.querySelector('[data-sf-pair1-notify-row]');
    var pair2NotifyRow = root.querySelector('[data-sf-pair2-notify-row]');

    function checked(selector) {
      return root.querySelector(selector + ':checked');
    }

    function getPairValue(pair, kind) {
      var input = checked('[data-sf-pair="' + pair + '"][data-sf-kind="' + kind + '"]');
      return input ? input.value : '';
    }

    function getBandValue() {
      var input = checked('[data-opt-index="' + bandIndex + '"]');
      return input ? input.value : '';
    }
    function getBandNumberForBogo(value) {
  var raw = value && value.value ? value.value : value;
  var s = String(raw || '').toLowerCase().trim();

  var match = s.match(/(\d+)\s*bands?\b/);
  if (match && match[1]) {
    var n = parseInt(match[1], 10);
    if (n === 4 || n === 6 || n === 8 || n === 10) return n;
  }

  if (s.indexOf('10') > -1) return 10;
  if (s.indexOf('8') > -1) return 8;
  if (s.indexOf('6') > -1) return 6;
  if (s.indexOf('4') > -1) return 4;

  return 4;
}

function updateBogoBandInfoText(bandValue) {
  if (!masterBands) return;

  var textEl = masterBands.querySelector('[data-sf-bandinfo-text]');
  if (!textEl) return;

  var n = getBandNumberForBogo(bandValue);
  var t4 = textEl.getAttribute('data-t4') || '';
  var t6 = textEl.getAttribute('data-t6') || t4;
  var t8 = textEl.getAttribute('data-t8') || t6 || t4;
  var t10 = textEl.getAttribute('data-t10') || t8 || t6 || t4;

  textEl.textContent = n === 10 ? t10 : n === 8 ? t8 : n === 6 ? t6 : t4;
}

    function findVariant(list, color, size, band) {
      for (var i = 0; i < list.length; i++) {
        var v = list[i];
        if (!v || !v.options) continue;

        if (
          v.options[colorIndex] === color &&
          v.options[sizeIndex] === size &&
          v.options[bandIndex] === band
        ) {
          return v;
        }
      }

      return null;
    }

    function isSellable(v) {
      return !!(v && v.available);
    }
    function setBogoSizeChipAvailability(pair, variantsList, selectedColor, selectedBand) {
  var inputs = Array.prototype.slice.call(
    root.querySelectorAll('[data-sf-pair="' + pair + '"][data-sf-kind="size"]')
  );

  inputs.forEach(function (input) {
    var size = input.value;
    var variant = findVariant(variantsList, selectedColor, size, selectedBand);
    var isUnavailable = !isSellable(variant);

    var label = input.id ? root.querySelector('label[for="' + input.id + '"]') : null;

    input.disabled = false;
    input.setAttribute('data-sf-bogo-unavailable', isUnavailable ? 'true' : 'false');

    if (label) {
      label.setAttribute('data-sf-bogo-unavailable', isUnavailable ? 'true' : 'false');
      label.setAttribute('aria-disabled', 'false');
    }
  });
}

function updateBogoSizeAvailability(bundle) {
  if (!bundle || !bundle.band) return;

  setBogoSizeChipAvailability(
    1,
    paidVariants,
    bundle.pair1Color,
    bundle.band
  );

  setBogoSizeChipAvailability(
    2,
    pair2Variants,
    bundle.pair2Color || bundle.pair1Color,
    bundle.band
  );
}

    function formatPairText(color, size, band) {
      var parts = [];
      if (color) parts.push(color);
      if (size) parts.push(size);
      if (band) parts.push(band);
      return parts.join(', ');
    }

    function getBundleSelections() {
      var pair1Color = getPairValue(1, 'color');
      var pair1Size = getPairValue(1, 'size');
      var pair2Color = getPairValue(2, 'color') || pair1Color;
      var pair2Size = getPairValue(2, 'size') || pair1Size;
      var band = getBandValue();

      var pair1Variant = findVariant(paidVariants, pair1Color, pair1Size, band);
      var pair2Variant = findVariant(pair2Variants, pair2Color, pair2Size, band);

      return {
        pair1Color: pair1Color,
        pair1Size: pair1Size,
        pair2Color: pair2Color,
        pair2Size: pair2Size,
        band: band,
        pair1Variant: pair1Variant,
        pair2Variant: pair2Variant,
        pair1Text: formatPairText(pair1Color, pair1Size, band),
        pair2Text: formatPairText(pair2Color, pair2Size, band)
      };
    }

    function isPair1Ready(bundle) {
      return !!(bundle && bundle.pair1Color && bundle.pair1Size && bundle.band && bundle.pair1Variant);
    }
    function canGoToPair2(bundle) {
  return !!(
    bundle &&
    bundle.pair1Color &&
    bundle.pair1Size &&
    bundle.band &&
    bundle.pair1Variant &&
    isSellable(bundle.pair1Variant)
  );
}
function isPair2InvalidAfterVisit(bundle) {
  return !!(
    hasVisitedStep2 &&
    bundle &&
    bundle.pair2Color &&
    bundle.pair2Size &&
    bundle.band &&
    !isSellable(bundle.pair2Variant)
  );
}
function markPair2InvalidOnLoad(bundle) {
  if (
    !hasVisitedStep2 &&
    activeStep === 1 &&
    bundle &&
    isSellable(bundle.pair1Variant) &&
    bundle.pair2Color &&
    bundle.pair2Size &&
    bundle.band &&
    !isSellable(bundle.pair2Variant)
  ) {
    hasVisitedStep2 = true;
  }
}

function updateSummaryValidation(bundle) {
  var pair1Card = root.querySelector('[data-sf-step-card="1"]');
  var pair2Card = root.querySelector('[data-sf-step-card="2"]');

  // Pair 1 should never show the red invalid border.
  // If Pair 1 is out of stock, the ATC handles it as Notify Me instead.
  if (pair1Card) {
    pair1Card.classList.remove('is-invalid');
  }

  // Pair 2 should only show red invalid state after user has opened Pair 2.
  var pair2Invalid = !!(
    hasVisitedStep2 &&
    bundle &&
    bundle.pair2Color &&
    bundle.pair2Size &&
    bundle.band &&
    !isSellable(bundle.pair2Variant)
  );

  if (pair2Card) {
    pair2Card.classList.toggle('is-invalid', pair2Invalid);
  }
}

    function setLabelSelected(input) {
      if (!input || !input.id) return;
      var groupName = input.getAttribute('name');
      if (groupName) {
        root.querySelectorAll('input[name="' + groupName + '"]').forEach(function (item) {
          var label = item.id ? root.querySelector('label[for="' + item.id + '"]') : null;
          if (label) label.classList.toggle('is-selected', item.checked);
        });
      }
    }

function isCurrentPair1NotifyState() {
  var bundle = getBundleSelections();
  return !!(bundle && !isSellable(bundle.pair1Variant));
}

function forceAtcAvailableState() {
  if (!atcBtn || isSubmittingBundle) return;

  atcBtn.disabled = false;
  atcBtn.removeAttribute('disabled');
  atcBtn.removeAttribute('aria-disabled');

  atcBtn.classList.remove('disabled');
  atcBtn.classList.remove('is-disabled');
  atcBtn.classList.remove('button--disabled');
  atcBtn.classList.remove('shopify-payment-button__button--disabled');
  atcBtn.classList.remove('is-notify');
  atcBtn.classList.remove('is-out-of-stock');

  atcBtn.style.pointerEvents = 'auto';
  atcBtn.style.cursor = 'pointer';
  atcBtn.style.opacity = '1';

  atcBtn.setAttribute('type', 'submit');
}

function forceAtcClickableForNotify() {
  if (!atcBtn || isSubmittingBundle) return;

  // Do not let old delayed timers keep Notify Me after user selects an available Pair 1 variant.
  if (!isCurrentPair1NotifyState()) {
    forceAtcAvailableState();
    return;
  }

  atcBtn.disabled = false;
  atcBtn.removeAttribute('disabled');
  atcBtn.removeAttribute('aria-disabled');

  atcBtn.classList.remove('disabled');
  atcBtn.classList.remove('is-disabled');
  atcBtn.classList.remove('button--disabled');
  atcBtn.classList.remove('shopify-payment-button__button--disabled');
  atcBtn.classList.add('is-notify');
  atcBtn.classList.remove('is-out-of-stock');

  atcBtn.style.pointerEvents = 'auto';
  atcBtn.style.cursor = 'pointer';
  atcBtn.style.opacity = '1';

  atcBtn.setAttribute('type', 'button');

  if (atcText) {
    atcText.textContent = 'NOTIFY ME WHEN BACK IN STOCK';
  }
}

function setAtcState(bundle) {
  var pair1Ok = isSellable(bundle.pair1Variant);
  var pair2Ok = isSellable(bundle.pair2Variant);

  // Pair 1 out of stock = Klaviyo Notify Me.
  var shouldNotify = !pair1Ok;

  // Pair 2 out of stock = block purchase, do NOT open Klaviyo.
  var pair2Invalid = pair1Ok && isPair2InvalidAfterVisit(bundle);
  var shouldShowPair2OutOfStock = pair2Invalid && activeStep === 2;
  var shouldGoBackToPair2 = pair2Invalid && activeStep === 1;

  if (isSubmittingBundle) {
    atcBtn.disabled = true;
    atcBtn.setAttribute('disabled', 'disabled');
    atcBtn.setAttribute('aria-disabled', 'true');
    atcBtn.classList.remove('is-notify');
    atcBtn.classList.remove('is-out-of-stock');
    atcBtn.style.pointerEvents = '';
    atcBtn.style.cursor = 'not-allowed';
  } else if (shouldNotify) {
    forceAtcClickableForNotify();
    atcBtn.classList.add('is-notify');
    atcBtn.classList.remove('is-out-of-stock');
  } else if (shouldShowPair2OutOfStock) {
    atcBtn.disabled = true;
    atcBtn.setAttribute('disabled', 'disabled');
    atcBtn.setAttribute('aria-disabled', 'true');
    atcBtn.setAttribute('type', 'button');

    atcBtn.classList.remove('is-notify');
    atcBtn.classList.add('is-out-of-stock');
    atcBtn.classList.remove('disabled');
    atcBtn.classList.remove('is-disabled');
    atcBtn.classList.remove('button--disabled');

    atcBtn.style.pointerEvents = '';
    atcBtn.style.cursor = 'not-allowed';
    atcBtn.style.opacity = '';
  } else {
    forceAtcAvailableState();
  }

  if (atcText) {
    if (isSubmittingBundle) {
      atcText.textContent = 'ADDING...';
    } else if (shouldNotify) {
      atcText.textContent = 'NOTIFY ME WHEN BACK IN STOCK';
    } else if (shouldShowPair2OutOfStock) {
      atcText.textContent = 'OUT OF STOCK - CHOOSE A DIFFERENT VARIANT';
    } else if (shouldGoBackToPair2) {
      atcText.textContent = 'CONTINUE TO PAIR 2';
    } else {
      atcText.textContent = 'TRY IT RISK-FREE — 2 PAIRS · ' + formatMoney(bundle.pair1Variant.price);
    }
  }

  if (shouldNotify && !isSubmittingBundle) {
    window.setTimeout(forceAtcClickableForNotify, 0);
    window.setTimeout(forceAtcClickableForNotify, 50);
    window.setTimeout(forceAtcClickableForNotify, 150);
    window.setTimeout(forceAtcClickableForNotify, 500);
    window.setTimeout(forceAtcClickableForNotify, 1200);
  } else {
    window.setTimeout(function () {
      var latestBundle = getBundleSelections();
      var latestPair1Ok = isSellable(latestBundle.pair1Variant);
      var latestPair2Invalid = latestPair1Ok && isPair2InvalidAfterVisit(latestBundle);
      var latestPair2OutOfStock = latestPair2Invalid && activeStep === 2;
      var latestGoBackToPair2 = latestPair2Invalid && activeStep === 1;

      if (!latestPair1Ok) {
        forceAtcClickableForNotify();

        if (atcText && !isSubmittingBundle) {
          atcText.textContent = 'NOTIFY ME WHEN BACK IN STOCK';
        }

        return;
      }

      if (latestPair2OutOfStock) {
        atcBtn.disabled = true;
        atcBtn.setAttribute('disabled', 'disabled');
        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn.setAttribute('type', 'button');
        atcBtn.classList.remove('is-notify');
        atcBtn.classList.add('is-out-of-stock');
        atcBtn.style.pointerEvents = '';
        atcBtn.style.cursor = 'not-allowed';

        if (atcText && !isSubmittingBundle) {
          atcText.textContent = 'OUT OF STOCK - CHOOSE A DIFFERENT VARIANT';
        }

        return;
      }

      forceAtcAvailableState();

      if (atcText && !isSubmittingBundle) {
        latestBundle = getBundleSelections();
        atcText.textContent = latestGoBackToPair2
          ? 'CONTINUE TO PAIR 2'
          : 'TRY IT RISK-FREE — 2 PAIRS · ' + formatMoney(latestBundle.pair1Variant.price);
      }
    }, 50);
  }
}

    function getActiveGalleryColor(bundle) {
  if (!bundle) bundle = getBundleSelections();

  if (activeStep === 2) {
    return bundle.pair2Color || bundle.pair1Color || '';
  }

  return bundle.pair1Color || bundle.pair2Color || '';
}

function updateBogoGallery(bundle) {
  var color = getActiveGalleryColor(bundle);
  if (!color) return;

  applyColorFilter(root, color);

  var activeColorInput = null;

  if (activeStep === 2) {
    activeColorInput =
      root.querySelector('[data-sf-pair="2"][data-sf-kind="color"]:checked') ||
      root.querySelector('[data-sf-pair="1"][data-sf-kind="color"]:checked');
  } else {
    activeColorInput =
      root.querySelector('[data-sf-pair="1"][data-sf-kind="color"]:checked') ||
      root.querySelector('[data-sf-pair="2"][data-sf-kind="color"]:checked');
  }

  var targetMediaId = activeColorInput ? activeColorInput.getAttribute('data-target-media-id') : '';

  if (targetMediaId) {
    scrollToMediaId(targetMediaId);
  }
}

    function updateSummaryImages(bundle) {
      var img1 = root.querySelector('[data-sf-summary-image="1"]');
      var img2 = root.querySelector('[data-sf-summary-image="2"]');

      if (img1 && bundle.pair1Variant) {
        var src1 = '';

        if (bundle.pair1Variant.featured_image && bundle.pair1Variant.featured_image.src) {
          src1 = bundle.pair1Variant.featured_image.src;
        } else if (bundle.pair1Variant.image) {
          src1 = bundle.pair1Variant.image;
        }

        if (src1) img1.src = src1;
      }

      if (img2 && bundle.pair2Variant) {
        var src2 = '';

        if (bundle.pair2Variant.featured_image && bundle.pair2Variant.featured_image.src) {
          src2 = bundle.pair2Variant.featured_image.src;
        } else if (bundle.pair2Variant.image) {
          src2 = bundle.pair2Variant.image;
        }

        if (src2) img2.src = src2;
      }
    }

    function updateSummaryTitles(bundle) {
      var p1 = root.querySelector('[data-sf-pair-color-text="1"]');
      var p2 = root.querySelector('[data-sf-pair-color-text="2"]');

      if (p1) p1.textContent = bundle.pair1Color || '';
      if (p2) p2.textContent = bundle.pair2Color || '';
    }

    function updateHiddenPairProperties(bundle) {
      if (pair1PropInput) pair1PropInput.value = bundle.pair1Text || '';
      if (pair2PropInput) pair2PropInput.value = bundle.pair2Text || '';

      if (variantIdInput && bundle.pair1Variant) {
        variantIdInput.value = bundle.pair1Variant.id;
      }
    }

function updateNotifyRows(bundle) {
  if (pair1NotifyRow) {
    pair1NotifyRow.hidden = isSellable(bundle.pair1Variant);
  }

  // Always hide Pair 2 notify helper row
  if (pair2NotifyRow) {
    pair2NotifyRow.hidden = true;
  }
}

    function buildPair2BandMirror() {
      if (!masterBands) return null;

      var checkedBand = masterBands.querySelector('[data-opt-index="' + bandIndex + '"]:checked');
      var checkedLabel = checkedBand && checkedBand.id
        ? masterBands.querySelector('label[for="' + checkedBand.id + '"]')
        : null;

      if (!checkedLabel) return null;

      var wrap = document.createElement('div');
      wrap.className = 'sf-bogo-band-mirror-single';

      var grid = document.createElement('div');
      grid.className = 'sf-bandgrid';

      var clone = checkedLabel.cloneNode(true);
      clone.classList.add('is-selected');
      clone.removeAttribute('for');
      clone.removeAttribute('aria-disabled');

      grid.appendChild(clone);
      wrap.appendChild(grid);

      var info = masterBands.querySelector('.sf-bandinfo');
      if (info) wrap.appendChild(info.cloneNode(true));

      return wrap;
    }

    function mountBandSlots() {
      if (!masterBands) return;

      if (pair1BandSlot && masterBands.parentNode !== pair1BandSlot) {
        pair1BandSlot.innerHTML = '';
        pair1BandSlot.appendChild(masterBands);
      }

      if (pair2BandSlot) {
        pair2BandSlot.innerHTML = '';
        var mirror = buildPair2BandMirror();
        if (mirror) pair2BandSlot.appendChild(mirror);
      }

      masterBands.removeAttribute('hidden');

      if (masterBandsShell) {
        masterBandsShell.style.display = 'none';
      }
    }

function updateStepUI(bundle) {
  var pair1CanContinue = canGoToPair2(bundle);
  var pair2Invalid = isPair2InvalidAfterVisit(bundle);

  // If Pair 1 becomes unavailable, user must stay on Pair 1.
  if (activeStep === 2 && !pair1CanContinue) {
    activeStep = 1;
  }


  wizard.setAttribute('data-sf-active-step', String(activeStep));

  if (stepLabel) {
    stepLabel.textContent = 'STEP ' + activeStep + ' / 2';
  }

  if (stepProgress) {
    stepProgress.style.width = activeStep === 2
      ? 'calc(100% - var(--sf-step-label-space, 92px))'
      : 'calc((100% - var(--sf-step-label-space, 92px)) * 0.5)';
  }

  if (stepLastDot) {
    stepLastDot.classList.toggle('is-complete', activeStep === 2);
  }

  stepPanels.forEach(function (panel) {
    var on = panel.getAttribute('data-sf-step-panel') === String(activeStep);
    panel.classList.toggle('is-active', on);
    panel.hidden = !on;
  });

  stepCards.forEach(function (card) {
    var step = parseInt(card.getAttribute('data-sf-step-card') || '1', 10);

    // Pair 2 hard locked = Pair 1 is not available.
    var pair2HardLocked = step === 2 && !pair1CanContinue;

    // Pair 2 pending = Pair 1 is available, but Pair 2 has not been opened yet.
    var pair2Pending = step === 2 && pair1CanContinue && !hasVisitedStep2 && activeStep !== 2;

// Pair 1 should NEVER be locked by Pair 2.
// Pair 2 out of stock should only affect Pair 2.
var pair1LockedByPair2 = false;

// is-active = this pair has been selected/unlocked.
// is-current = user is currently editing this pair.
// Important: locked/pending cards must never look super active.
var pairSelected = step === 1 || (step === 2 && hasVisitedStep2);
var cardLocked = pair2HardLocked;

card.classList.toggle('is-active', pairSelected && !pair2Pending);
card.classList.toggle('is-current', step === activeStep && !cardLocked && !pair2Pending);
card.classList.toggle('is-locked', cardLocked);
card.classList.toggle('is-pending', pair2Pending);
if (pair2HardLocked) {
  card.setAttribute('aria-disabled', 'true');
  card.disabled = true;
} else {
  card.setAttribute('aria-disabled', 'false');
  card.disabled = false;
}
  });

  updateSummaryValidation(bundle);
}

function formatMoney(cents) {
  cents = Number(cents || 0);

  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return window.Shopify.formatMoney(cents, moneyFormat);
  }

  return '$' + (cents / 100).toFixed(2);
}

function updateBogoPriceFromVariant(v) {
  if (!v) return;

  var pv = presentById[String(v.id)] || null;

  if (variantIdInput) {
    variantIdInput.value = v.id;
  }

  if (priceEl) {
    priceEl.textContent = pv && pv.price_html ? pv.price_html : formatMoney(v.price);
  }

  var hasCompare = pv
    ? !!pv.has_compare
    : !!(v.compare_at_price && v.compare_at_price > v.price);

  if (compareEl) {
    compareEl.style.display = hasCompare ? 'inline' : 'none';

    if (hasCompare) {
      compareEl.textContent = pv && pv.compare_html
        ? pv.compare_html
        : formatMoney(v.compare_at_price);
    }
  }

  if (saveWrap) {
    saveWrap.style.display = hasCompare ? 'inline-flex' : 'none';
  }

  if (hasCompare) {
    var pct = pv && typeof pv.save_pct !== 'undefined'
      ? pv.save_pct
      : Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);

    if (savePill) {
      savePill.textContent = '-' + pct + '% OFF';
    }

    if (saveText) {
      saveText.textContent = 'SAVE UP TO ' + (
        pv && pv.save_amt_html
          ? pv.save_amt_html
          : formatMoney(v.compare_at_price - v.price)
      );
    }
  }
}
function updateBundleState() {
  var bundle = getBundleSelections();

  markPair2InvalidOnLoad(bundle);

  updateSummaryTitles(bundle);
  updateSummaryImages(bundle);
  updateBogoGallery(bundle);
  updateHiddenPairProperties(bundle);
  updateBogoPriceFromVariant(bundle.pair1Variant);
  updateNotifyRows(bundle);

  // Important: normal onAnyChange() does not run in BOGO mode,
  // so the band info text must be updated here.
  updateBogoBandInfoText(bundle.band);
  updateBogoSizeAvailability(bundle);

  // IMPORTANT: update PDP visible price from the PAID pair variant.
  if (bundle.pair1Variant && typeof updateUIFromVariant === 'function') {
    updateUIFromVariant(bundle.pair1Variant);
  }

  mountBandSlots();
  updateStepUI(bundle);
  setAtcState(bundle);

  return bundle;
}

    function buildBundleItems(bundle) {
      var groupId = 'bogo_' + Date.now() + '_' + Math.random().toString(36).slice(2);

      var paidProps = {
        'Pair 1': bundle.pair1Text,
        'Pair 2': bundle.pair2Text,
        '_bundle_type': 'free_pair',
        '_bundle_mode': 'custom_bogo_pairs',
        '_bundle_group': groupId,
        '_bundle_role': 'paid',
        '_pair_role': 'paid',
        '_pair_1_variant_id': String(bundle.pair1Variant.id),
        '_pair_2_variant_id': String(bundle.pair2Variant.id)
      };

      var freeProps = {
        'Pair 1': bundle.pair1Text,
        'Pair 2': bundle.pair2Text,
        '_bundle_type': 'free_pair',
        '_bundle_mode': 'custom_bogo_pairs',
        '_bundle_group': groupId,
        '_bundle_role': 'free',
        '_pair_role': 'free',
        '_pair_1_variant_id': String(bundle.pair1Variant.id),
        '_pair_2_variant_id': String(bundle.pair2Variant.id)
      };

      if (!usingExternalFreePairProduct && String(bundle.pair1Variant.id) === String(bundle.pair2Variant.id)) {
        return [
          {
            id: bundle.pair1Variant.id,
            quantity: 2,
            properties: paidProps
          }
        ];
      }

      return [
        {
          id: bundle.pair2Variant.id,
          quantity: 1,
          properties: freeProps
        },
        {
          id: bundle.pair1Variant.id,
          quantity: 1,
          properties: paidProps
        }
      ];
    }

    function getCartAddUrl() {
      return window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js';
    }

function trackOpenAiItemsAdded(bundle) {
  if (!bundle || !bundle.pair1Variant) return;

  try {
    var amount = Number(bundle.pair1Variant.price || 0);
    var currency =
      (window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active) ||
      'USD';

    if (typeof window.oaiq === 'function') {
      window.oaiq('measure', 'items_added', {
        type: 'contents',
        amount: amount,
        currency: currency,
        contents: [
          {
            id: String(bundle.pair1Variant.id || ''),
            name: bundle.pair1Text || 'BOGO paid pair',
            content_type: 'product',
            quantity: 1,
            amount: amount,
            currency: currency
          }
        ]
      });
    }
  } catch (error) {
    if (window.console && error) {
      console.warn('[OpenAI Ads] items_added tracking failed:', error);
    }
  }
}

function openCartDrawer(addResponse) {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return false;

  function removeEmptyCartState() {
    drawer.classList.remove('is-empty');
    drawer.removeAttribute('is-empty');

    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');

    var shell = drawer.querySelector('.sf-cartdrawer-shell');
    if (shell) shell.classList.remove('drawer__inner-empty');

    var drawerItems = drawer.querySelector('cart-drawer-items');
    if (drawerItems) drawerItems.classList.remove('is-empty');

    var checkout = drawer.querySelector('#CartDrawer-Checkout');
    if (checkout) checkout.disabled = false;
  }

  function renderCartDrawerSection() {
    if (!addResponse || !addResponse.sections || !addResponse.sections['cart-drawer']) {
      return false;
    }

    var html = new DOMParser().parseFromString(addResponse.sections['cart-drawer'], 'text/html');

    var newInner =
      html.querySelector('#CartDrawer .drawer__inner') ||
      html.querySelector('cart-drawer .drawer__inner') ||
      html.querySelector('.drawer__inner');

    var currentInner = drawer.querySelector('.drawer__inner');

    if (newInner && currentInner) {
      currentInner.replaceWith(newInner);
      return true;
    }

    return false;
  }

  function renderCartIconBubble() {
    if (!addResponse || !addResponse.sections || !addResponse.sections['cart-icon-bubble']) {
      return;
    }

    var html = new DOMParser().parseFromString(addResponse.sections['cart-icon-bubble'], 'text/html');
    var currentBubble = document.getElementById('cart-icon-bubble');
    var newBubble = html.getElementById('cart-icon-bubble');

    if (currentBubble && newBubble) {
      currentBubble.replaceWith(newBubble);
    }
  }

  try {
    renderCartDrawerSection();
    renderCartIconBubble();
    removeEmptyCartState();

    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      drawer.classList.add('active');
      drawer.setAttribute('open', '');
    }

    return true;
  } catch (err) {
    if (window.console && err) console.error(err);
  }

  try {
    if (typeof drawer.renderContents === 'function' && addResponse) {
      drawer.renderContents(addResponse);
      removeEmptyCartState();

      if (typeof drawer.open === 'function') {
        drawer.open();
      }

      return true;
    }
  } catch (err2) {}

  try {
    removeEmptyCartState();

    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      drawer.classList.add('active');
      drawer.setAttribute('open', '');
    }

    return true;
  } catch (err3) {}

  return false;
}

    function addBundleToCart(bundle) {
      var items = buildBundleItems(bundle);

      isSubmittingBundle = true;
      atcBtn.disabled = true;
      if (atcText) atcText.textContent = 'ADDING...';
      if (spinner) spinner.classList.remove('hidden');

      return fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
  items: items,
  sections: ['cart-drawer', 'cart-icon-bubble'],
  sections_url: window.location.pathname + window.location.search
})
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw err;
            });
          }
          return res.json();
        })
.then(function (addResponse) {
  trackOpenAiItemsAdded(bundle);
  openCartDrawer(addResponse);
})
        .catch(function (err) {
          console.error('BOGO add failed:', err);
          var message = root.querySelector('.product-form__error-message');
          var wrapper = root.querySelector('.product-form__error-message-wrapper');

          if (message) {
            message.textContent = err && err.description ? err.description : 'Could not add this bundle to cart.';
          }

          if (wrapper) {
            wrapper.hidden = false;
          }
        })
        .finally(function () {
          isSubmittingBundle = false;
          if (spinner) spinner.classList.add('hidden');
          updateBundleState();
        });
    }

stepCards.forEach(function (card) {
  card.addEventListener('click', function () {
    var step = parseInt(card.getAttribute('data-sf-step-card') || '1', 10);
    var bundle = getBundleSelections();

    // Do not allow Pair 2 until Pair 1 is available.
    if (step === 2 && !canGoToPair2(bundle)) {
      activeStep = 1;

      window.requestAnimationFrame(function () {
        updateBundleState();
      });

      return;
    }

    activeStep = step === 2 ? 2 : 1;

    if (activeStep === 2) {
      hasVisitedStep2 = true;
    }

    window.requestAnimationFrame(function () {
      updateBundleState();
    });
  });
});

root.addEventListener('change', function (event) {
  var input = event.target;
  if (!input || !input.matches('.sf-bogo-input, [data-sf-master-bands] .sf-opt-input')) return;

  setLabelSelected(input);

  window.requestAnimationFrame(function () {
    var bundle = updateBundleState();

    // Safety refresh after radio checked state has fully settled.
    window.setTimeout(function () {
      updateBundleState();
    }, 0);
  });
});

atcBtn.addEventListener('click', function (event) {
  var bundle = getBundleSelections();

  var pair1Ok = isSellable(bundle.pair1Variant);
  var pair2Ok = isSellable(bundle.pair2Variant);
  var pair2Invalid = pair1Ok && isPair2InvalidAfterVisit(bundle);

  if (pair1Ok && pair2Ok) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  // Pair 1 out of stock = open Notify Me.
if (!pair1Ok) {
  forceAtcClickableForNotify();

  if (variantIdInput && bundle.pair1Variant) {
    variantIdInput.value = bundle.pair1Variant.id;
  }

  window.setTimeout(function () {
    if (typeof window.sfTriggerKlaviyoBis === 'function') {
      window.sfTriggerKlaviyoBis();
    }
  }, 150);

  return;
}

  // Pair 2 out of stock = take user back to Pair 2.
  // Do not open Notify Me and do not make Pair 1 look out of stock.
  if (pair2Invalid) {
    activeStep = 2;
    hasVisitedStep2 = true;

    window.requestAnimationFrame(function () {
      updateBundleState();
    });

    return;
  }
}, true);

form.addEventListener('submit', function (event) {
  var bundle = updateBundleState();

  var pair1Ok = isSellable(bundle.pair1Variant);
  var pair2Ok = isSellable(bundle.pair2Variant);

  if (!pair1Ok) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    forceAtcClickableForNotify();

    if (variantIdInput && bundle.pair1Variant) {
      variantIdInput.value = bundle.pair1Variant.id;
    }

    if (typeof window.sfTriggerKlaviyoBis === 'function') {
      window.sfTriggerKlaviyoBis();
    }

    return;
  }

  if (!pair2Ok) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    // Pair 2 out of stock should NOT open Klaviyo.
    activeStep = 2;
    hasVisitedStep2 = true;

    window.requestAnimationFrame(function () {
      updateBundleState();
    });

    return;
  }

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  addBundleToCart(bundle);
}, true);

    updateBundleState();
    wizard.removeAttribute('data-sf-bogo-loading');
wizard.classList.add('is-ready');
  }

function initReviewFeatures(root) {
  root.querySelectorAll('[data-sf-rf]').forEach(function (block) {
    if (block.__sfRfInit) return;
    block.__sfRfInit = true;

    var track = block.querySelector('[data-sf-rf-track]');
    var slides = Array.prototype.slice.call(block.querySelectorAll('[data-sf-rf-slide]'));
    var dots = Array.prototype.slice.call(block.querySelectorAll('[data-sf-rf-dot]'));

    if (!track || !slides.length || !dots.length) return;

    function getSlideLeft(slide) {
      return slide.offsetLeft - track.offsetLeft;
    }

    function getActiveIndex() {
      var trackRect = track.getBoundingClientRect();
      var trackLeft = trackRect.left;
      var bestIndex = 0;
      var bestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var slideRect = slide.getBoundingClientRect();
        var distance = Math.abs(slideRect.left - trackLeft);

        if (distance < bestDistance) {
          bestDistance = distance;
          bestIndex = index;
        }
      });

      return bestIndex;
    }

    function setActive(index) {
      dots.forEach(function (dot, dotIndex) {
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    }

    function goToSlide(index) {
      var target = slides[index];
      if (!target) return;

      track.scrollTo({
        left: getSlideLeft(target),
        behavior: 'smooth'
      });

      setActive(index);

      window.setTimeout(function () {
        setActive(getActiveIndex());
      }, 350);
    }

    dots.forEach(function (dot, index) {
      dot.setAttribute('data-sf-rf-dot-index', String(index));

      dot.addEventListener('click', function (event) {
        event.preventDefault();
        goToSlide(index);
      });
    });

    var raf = null;

    track.addEventListener('scroll', function () {
      if (raf) return;

      raf = requestAnimationFrame(function () {
        raf = null;
        setActive(getActiveIndex());
      });
    }, { passive: true });

    window.addEventListener('resize', function () {
      window.requestAnimationFrame(function () {
        setActive(getActiveIndex());
      });
    });

    setActive(0);
  });
}

function initRoot(root) {
    if (!root || root.__sfPdpUnifiedInit) return;
    root.__sfPdpUnifiedInit = true;

    var sfRevealFallbackTimer = window.setTimeout(function () {
      revealSfPdpRoot(root);
    }, 1200);

    cleanLooxLabels(root);
formatRelatedLooxLabels(root);
   initDots(root);
initGalleryVideo(root);
initVideoScrollbar(root);
initBandWidths(root);
initBogoPairs(root);
initReviewFeatures(root);

    var variants = parseJsonScript(root.getAttribute('data-variants-id')) || [];
    var presentPayload = parseJsonScript(root.getAttribute('data-presentment-id')) || {};
    var presentById = {};
    (presentPayload.variants || []).forEach(function (row) {
      presentById[String(row.id)] = row;
    });
    var productJson = parseJsonScript(root.getAttribute('data-product-id')) || {};

    var ui = root.querySelector('[data-sf-variant-ui]');
    var priceWrap = root.querySelector('[data-sf-price-wrap]');
    var moneyFormat = priceWrap
      ? (priceWrap.getAttribute('data-money-format') || root.getAttribute('data-money-format') || '{{amount}}')
      : (root.getAttribute('data-money-format') || '{{amount}}');

    var priceEl = root.querySelector('[data-sf-price]');
    var compareEl = root.querySelector('[data-sf-compare]');
    var saveWrap = root.querySelector('[data-sf-save-wrap]');
    var saveText = root.querySelector('[data-sf-save-text]');
    var savePill = root.querySelector('[data-sf-save-pill]');
    var atcBtn = root.querySelector('[data-sf-atc]');
    var stockUrgency = root.querySelector('[data-sf-stock-urgency]');
    var sizeNotifyWrap = root.querySelector('[data-sf-size-notify]');
    var inlineNotifyBtn = root.querySelector('[data-sf-inline-notify]');
    var stockTextEl = root.querySelector('[data-sf-stock-text]');
    var stockFillEl = root.querySelector('[data-sf-stock-fill]');
    var atcText = root.querySelector('[data-sf-atc-text]');
    var variantIdInput = root.querySelector('[data-sf-variant-id]');
    var selectedColorLabel = root.querySelector('[data-sf-selected-label]');
    var bandSelectedLabel = root.querySelector('[data-sf-band-selected]');
    var bandInfoText = root.querySelector('[data-sf-bandinfo-text]');
    var productHandle = root.getAttribute('data-product-handle') || (productJson && productJson.handle) || '';

    var colorIndex = ui && ui.hasAttribute('data-color-index') ? parseInt(ui.getAttribute('data-color-index'), 10) : null;
    var sizeIndex = ui && ui.hasAttribute('data-size-index') ? parseInt(ui.getAttribute('data-size-index'), 10) : null;
    var bandIndex = ui && ui.hasAttribute('data-band-index') ? parseInt(ui.getAttribute('data-band-index'), 10) : null;

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      var raw = typeof cents === 'string' ? cents.replace(/[^0-9.-]/g, '') : cents;
      var centsNum = Number(raw);
      if (!isFinite(centsNum)) centsNum = 0;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision == null ? 2 : precision;
        thousands = thousands || ',';
        decimal = decimal || '.';
        var num = (number / 100).toFixed(precision);
        var parts = num.split('.');
        var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        var centsPart = parts[1] ? decimal + parts[1] : '';
        return dollars + centsPart;
      }

      var format = moneyFormat || '{{amount}}';
      var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      var placeholder = match ? match[1] : 'amount';
      var formatted = '';

      switch (placeholder) {
        case 'amount':
          formatted = formatWithDelimiters(centsNum, 2, ',', '.');
          break;
        case 'amount_no_decimals':
          formatted = formatWithDelimiters(centsNum, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          formatted = formatWithDelimiters(centsNum, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          formatted = formatWithDelimiters(centsNum, 0, '.', ',');
          break;
        case 'amount_with_space_separator':
          formatted = formatWithDelimiters(centsNum, 2, ' ', '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          formatted = formatWithDelimiters(centsNum, 0, ' ', '.');
          break;
        case 'amount_with_apostrophe_separator':
          formatted = formatWithDelimiters(centsNum, 2, "'", '.');
          break;
        default:
          formatted = formatWithDelimiters(centsNum, 2, ',', '.');
      }

      return format.replace(/\{\{\s*\w+\s*\}\}/, formatted);
    }

    function getSelectedOptions() {
      if (!ui) return [];
      var count = parseInt(ui.getAttribute('data-option-count') || '0', 10);
      var out = new Array(count);
      for (var i = 0; i < count; i++) {
        var checked = root.querySelector('.sf-opt-input[data-opt-index="' + i + '"]:checked');
        out[i] = checked ? checked.value : null;
      }
      return out;
    }

    function findVariantByOptions(options) {
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var ok = true;
        for (var j = 0; j < options.length; j++) {
          if (options[j] && variant.options[j] !== options[j]) {
            ok = false;
            break;
          }
        }
        if (ok) return variant;
      }
      return null;
    }

    function setPressedState() {
      root.querySelectorAll('input.sf-opt-input').forEach(function (input) {
        var label = root.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        label.classList.toggle('is-selected', !!input.checked);
        var isUnavailable = input.getAttribute('data-sf-unavailable') === 'true';
        label.setAttribute('data-sf-unavailable', isUnavailable ? 'true' : 'false');
        label.setAttribute('aria-disabled', 'false');
      });
    }

    function updateDisabledStates() {
      if (!ui) return;
      var optionCount = parseInt(ui.getAttribute('data-option-count') || '0', 10);
      var selected = getSelectedOptions();

      for (var optIndex = 0; optIndex < optionCount; optIndex++) {
        var inputs = root.querySelectorAll('input.sf-opt-input[data-opt-index="' + optIndex + '"]');
        inputs.forEach(function (input) {
          var test = selected.slice();
          test[optIndex] = input.value;
          var possible = variants.some(function (variant) {
            if (!variant.available) return false;
            for (var j = 0; j < optionCount; j++) {
              if (test[j] && variant.options[j] !== test[j]) return false;
            }
            return true;
          });
          input.disabled = false;
          input.setAttribute('data-sf-unavailable', possible ? 'false' : 'true');
        });
      }
    }

    function scrollToMediaId(mediaId) {
      var id = String(mediaId || '').trim();
      if (!id) return;

      var slider = root.querySelector('[data-sf-slider]');
      var viewport = slider ? slider.querySelector('[data-sf-slider-viewport]') : null;
      if (viewport && window.matchMedia('(max-width: 749px)').matches) {
        var slide = slider.querySelector('[data-sf-media][data-media-id="' + id + '"]');
        if (slide) viewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        return;
      }

      var scroller = root.querySelector('[data-sf-gallery-scroll]');
      if (!scroller) return;
      var target = scroller.querySelector('.sf-mosaic [data-sf-media][data-media-id="' + id + '"]');
      if (!target) return;
      var top = target.offsetTop - scroller.offsetTop;
      scroller.scrollTo({ top: Math.max(0, top - 8), behavior: 'smooth' });
    }

function bandNumFromValue(val) {
  var s = String(val || '').toLowerCase().trim();

  var match = s.match(/(\d+)\s*bands?\b/);
  if (match && match[1]) {
    var n = parseInt(match[1], 10);
    if (n === 4 || n === 6 || n === 8 || n === 10) return n;
  }

  return 4;
}

function updateBandInfo(selectedVal) {
  if (!bandInfoText) return;
  var n = bandNumFromValue(selectedVal);
  var t4 = bandInfoText.getAttribute('data-t4') || '';
  var t6 = bandInfoText.getAttribute('data-t6') || t4;
  var t8 = bandInfoText.getAttribute('data-t8') || t6 || t4;
  var t10 = bandInfoText.getAttribute('data-t10') || t8 || t6 || t4;
  bandInfoText.textContent = n === 10 ? t10 : n === 8 ? t8 : n === 6 ? t6 : t4;
}

    function updateStockUrgency(v, pv) {
      if (!stockUrgency || !stockTextEl || !stockFillEl) return;
      var template = stockUrgency.getAttribute('data-stock-template') || 'Hurry! Only [stock] pairs are left in stock';
      var maxStockRaw = parseInt(stockUrgency.getAttribute('data-stock-max') || '100', 10);
      var maxStock = maxStockRaw > 0 ? maxStockRaw : 100;
      var hideWhenZero = stockUrgency.getAttribute('data-hide-when-zero') === 'true';
      var qty = 0;

      if (pv && typeof pv.inventory_quantity !== 'undefined' && pv.inventory_quantity !== null) {
        qty = parseInt(pv.inventory_quantity, 10);
      } else if (v && typeof v.inventory_quantity !== 'undefined' && v.inventory_quantity !== null) {
        qty = parseInt(v.inventory_quantity, 10);
      }
      if (!isFinite(qty) || qty < 0) qty = 0;

      var isTracked = pv ? !!pv.inventory_management : !!(v && v.inventory_management);
      var canContinueSelling = pv ? pv.inventory_policy === 'continue' : (v && v.inventory_policy === 'continue');

      if (!isTracked && hideWhenZero) {
        stockUrgency.hidden = true;
        return;
      }
      stockUrgency.hidden = hideWhenZero && qty <= 0;
      stockTextEl.textContent = template.replace('[stock]', String(qty));
      var pct = (qty / maxStock) * 100;
      if (!isFinite(pct)) pct = 0;
      pct = Math.max(0, Math.min(100, pct));
      stockFillEl.style.width = pct + '%';
      stockFillEl.classList.toggle('is-full', pct >= 100);
      if (canContinueSelling && qty <= 0 && hideWhenZero) stockUrgency.hidden = true;
    }

    if (inlineNotifyBtn) {
      inlineNotifyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var selectedOptions = getSelectedOptions();
        var matchedVariant = findVariantByOptions(selectedOptions);
        if (matchedVariant && variantIdInput) variantIdInput.value = matchedVariant.id;
        if (atcBtn && !atcBtn.disabled && /notify me when back in stock/i.test((atcBtn.textContent || '').trim())) {
          atcBtn.click();
          return;
        }
        if (typeof window.sfTriggerKlaviyoBis === 'function') window.sfTriggerKlaviyoBis();
      });
    }

    function updateUIFromVariant(v) {
      if (!v) return;
      if (variantIdInput) variantIdInput.value = v.id;
      var pv = presentById[String(v.id)] || null;

      if (priceEl) priceEl.textContent = pv && pv.price_html ? pv.price_html : formatMoney(v.price);

      var hasCompare = pv ? !!pv.has_compare : (v.compare_at_price && v.compare_at_price > v.price);

      if (sizeNotifyWrap) {
        var helperEnabled = sizeNotifyWrap.getAttribute('data-helper-enabled') === 'true';
        sizeNotifyWrap.hidden = !helperEnabled || !!v.available;
      }

      if (compareEl) {
        compareEl.style.display = hasCompare ? 'inline' : 'none';
        if (hasCompare) {
          compareEl.textContent = pv && pv.compare_html ? pv.compare_html : formatMoney(v.compare_at_price);
        }
      }

      if (saveWrap) saveWrap.style.display = hasCompare ? 'inline-flex' : 'none';

      if (hasCompare) {
        var pct = pv && typeof pv.save_pct !== 'undefined'
          ? pv.save_pct
          : (function () {
              var saveAmt = v.compare_at_price - v.price;
              return v.compare_at_price > 0 ? Math.round((saveAmt / v.compare_at_price) * 100) : 0;
            })();
        if (savePill) savePill.textContent = '-' + pct + '% OFF';
        if (saveText) {
          saveText.textContent = 'SAVE UP TO ' + (pv && pv.save_amt_html ? pv.save_amt_html : formatMoney(v.compare_at_price - v.price));
        }
      }

if (atcBtn) {
  var isBogoPdp = root.getAttribute('data-sf-enable-free-pair') === 'true';

  if (isBogoPdp) {
    // BOGO controls ATC state inside setAtcState().
    // Do not let normal variant UI disable the button.
    atcBtn.disabled = false;
    atcBtn.removeAttribute('disabled');
    atcBtn.removeAttribute('aria-disabled');
  } else {
    atcBtn.disabled = false;
    atcBtn.removeAttribute('disabled');
    atcBtn.removeAttribute('aria-disabled');

    if (v.available) {
      atcBtn.classList.remove('is-notify');
      atcBtn.style.pointerEvents = '';
      atcBtn.style.cursor = '';
    } else {
      atcBtn.classList.add('is-notify');
      atcBtn.style.pointerEvents = 'auto';
      atcBtn.style.cursor = 'pointer';
    }
  }
}
if (atcText) {
  var atcPriceStr = pv && pv.price_html ? pv.price_html : formatMoney(v.price);

  if (v.available) {
    atcText.textContent = 'TRY IT RISK-FREE — 2 PAIRS · ' + atcPriceStr;
  } else {
    atcText.textContent = 'NOTIFY ME WHEN BACK IN STOCK';
  }
}

      updateStockUrgency(v, pv);

      var limitedDropStock = root.querySelector('[data-sf-limited-drop-stock]');
      if (limitedDropStock) {
        var qty = 0;
        if (pv && typeof pv.inventory_quantity !== 'undefined' && pv.inventory_quantity !== null) {
          qty = parseInt(pv.inventory_quantity, 10);
        } else if (v && typeof v.inventory_quantity !== 'undefined' && v.inventory_quantity !== null) {
          qty = parseInt(v.inventory_quantity, 10);
        }
        if (!isFinite(qty) || qty < 0) qty = 0;
        limitedDropStock.textContent = qty;
      }

      if (root.getAttribute('data-update-url') === 'true' && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function onAnyChange() {
      updateDisabledStates();
      setPressedState();

      var selected = getSelectedOptions();
      var variant = findVariantByOptions(selected);
      if (!variant) {
        var currentId = variantIdInput ? parseInt(variantIdInput.value || '0', 10) : 0;
        variant = variants.find(function (x) { return x.id === currentId; }) || null;
      } else {
        updateUIFromVariant(variant);
      }

      if (colorIndex !== null) {
        var chosenColor = selected[colorIndex] || '';
        if (selectedColorLabel) selectedColorLabel.textContent = chosenColor;
        applyColorFilter(root, chosenColor);
        var colorInput = root.querySelector('input.sf-opt-input[data-opt-index="' + colorIndex + '"]:checked');
        var targetMediaId = colorInput ? colorInput.getAttribute('data-target-media-id') : '';
        if (targetMediaId) scrollToMediaId(targetMediaId);
      }

      if (bandIndex !== null) {
        var chosenBand = selected[bandIndex] || '';
        if (bandSelectedLabel) bandSelectedLabel.textContent = chosenBand;
        updateBandInfo(chosenBand);
      }
    }

    root.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.matches('.sf-opt-input')) return;

      if (
        root.getAttribute('data-sf-enable-free-pair') === 'true' &&
        (input.matches('.sf-bogo-input') || input.closest('[data-sf-master-bands]'))
      ) {
        return;
      }

      onAnyChange();
    });

    (function setupGalleryStartPosition() {
      var scroller = root.querySelector('[data-sf-gallery-scroll]');
      if (!scroller) return;
      var userScrolled = false;
      function goStart() {
        if (userScrolled) return;
        scroller.scrollTop = 0;
        scroller.scrollLeft = 0;
      }
      scroller.addEventListener('scroll', function () { userScrolled = true; }, { passive: true, once: true });
      try {
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      } catch (e) {}
      goStart();
      requestAnimationFrame(goStart);
      setTimeout(goStart, 60);
      scroller.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', goStart, { once: true });
      });
    })();

    root.addEventListener('click', function (e) {
      var fitFeelBtn = e.target.closest('[data-sf-fit-feel]');
      if (fitFeelBtn && root.contains(fitFeelBtn)) {
        e.preventDefault();
        e.stopPropagation();

        try {
          document.dispatchEvent(new CustomEvent('sf:fitfeel:open', {
            detail: {
              product: productJson,
              handle: productHandle
            }
          }));
        } catch (err) {}

        return;
      }

      var sizeGuideBtn = e.target.closest('[data-sf-size-guide], [data-sf-size-guide-secondary]');
      if (sizeGuideBtn && root.contains(sizeGuideBtn)) {
        e.preventDefault();
        e.stopPropagation();

        var sourceBtn = sizeGuideBtn.matches('[data-sf-size-guide-secondary]')
          ? root.querySelector('[data-sf-size-guide]')
          : sizeGuideBtn;

        if (!sourceBtn) sourceBtn = sizeGuideBtn;

        var payload = {
          title: (sourceBtn.textContent || '').trim() || 'Size guide',
          html: safeParseJsonAttr(sourceBtn, 'data-sf-sizeguide-html'),
          product_handle: productHandle
        };

        try {
          document.dispatchEvent(new CustomEvent('sf:sizeguide:open', { detail: payload }));
        } catch (err2) {}

        return;
      }

      var inlineNotifyBtn = e.target.closest('[data-sf-inline-notify]');
      if (inlineNotifyBtn && root.contains(inlineNotifyBtn)) {
        if (inlineNotifyBtn.closest('.sf-bogo-helper-row')) {
          e.preventDefault();
          e.stopPropagation();

          if (typeof window.sfTriggerKlaviyoBis === 'function') {
            window.sfTriggerKlaviyoBis();
          }
        }
      }
    }, true);

    var tabs = root.querySelector('[data-sf-tabs]');
    if (tabs) {
      var btns = tabs.querySelectorAll('.sf-tabbtn');
      var panels = tabs.querySelectorAll('.sf-tabpanel');
      function activateTab(key) {
        btns.forEach(function (btn) {
          var on = btn.getAttribute('data-tab') === key;
          btn.classList.toggle('is-active', on);
          btn.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-panel') === key);
        });
      }
      tabs.addEventListener('click', function (e) {
        var btn = e.target.closest('.sf-tabbtn');
        if (!btn) return;
        activateTab(btn.getAttribute('data-tab'));
      });
    }

    function postAdd(variantId) {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function (r) { return r.json(); });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sf-rec-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var row = btn.closest('[data-sf-rec-row]');
      if (!row) return;
      var variantId = parseInt(row.getAttribute('data-variant-id') || '0', 10);
      if (!variantId) return;
      var prev = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      postAdd(variantId).then(function () {
        btn.textContent = 'Added';
        try { document.dispatchEvent(new CustomEvent('sf:cart:refresh')); } catch (err) {}
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = prev;
        }, 1200);
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = prev;
      });
    });

    (function setupVideoTiles() {
      root.querySelectorAll('[data-sf-vtile]').forEach(function (tile) {
        if (tile.__sfVideoTileInit) return;
        tile.__sfVideoTileInit = true;
        var video = tile.querySelector('video.sf-filevideo');
        var btn = tile.querySelector('[data-sf-video-play]');
        var overlay = tile.querySelector('.sf-vcenter');
        if (!video || !btn || !overlay) return;

        function nudge() {
          try {
            if (video.readyState >= 2) {
              video.currentTime = 0.01;
              video.pause();
            }
          } catch (e) {}
        }

        video.addEventListener('loadeddata', nudge, { once: true });
        video.addEventListener('loadedmetadata', function () { setTimeout(nudge, 40); }, { once: true });
        video.addEventListener('pause', function () {
          if (video.currentTime === 0 || video.ended) overlay.style.display = '';
        });

        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          video.controls = true;
          video.muted = true;
          video.load();
          overlay.style.display = 'none';
          var playPromise = video.play();
          if (playPromise && playPromise.catch) {
            playPromise.catch(function () { overlay.style.display = ''; });
          }
          setTimeout(function () { video.muted = false; }, 150);
        });
      });
    })();

    (function setupEstimatedDelivery() {
      var cfg = root.querySelector('[data-sf-delivery-config]');
      var textEl = root.querySelector('[data-sf-est-delivery-text]');
      if (!cfg || !textEl) return;

      function toInt(v, fallback) {
        var n = parseInt(v, 10);
        return isNaN(n) ? fallback : n;
      }

      function addBusinessDays(startDate, businessDays) {
        var d = new Date(startDate.getTime());
        var added = 0;
        while (added < businessDays) {
          d.setDate(d.getDate() + 1);
          var day = d.getDay();
          if (day !== 0 && day !== 6) added++;
        }
        return d;
      }

      function formatDate(d) {
        return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
      }

      var enabled = String(cfg.getAttribute('data-delivery-enable')) === 'true';
      if (!enabled) return;

      var dynamic = String(cfg.getAttribute('data-delivery-dynamic')) === 'true';
      var prefix = cfg.getAttribute('data-delivery-prefix') || 'Estimated delivery date:';
      var manual = cfg.getAttribute('data-delivery-manual') || '';
      var country = (cfg.getAttribute('data-country-code') || '').toUpperCase();
      var usMin = toInt(cfg.getAttribute('data-delivery-us-min'), 1);
      var usMax = toInt(cfg.getAttribute('data-delivery-us-max'), 5);
      var caMin = toInt(cfg.getAttribute('data-delivery-ca-min'), 5);
      var caMax = toInt(cfg.getAttribute('data-delivery-ca-max'), 7);

      if (!dynamic) {
        textEl.textContent = manual || prefix;
        return;
      }

      var minDays = country === 'CA' ? caMin : usMin;
      var maxDays = country === 'CA' ? caMax : usMax;
      if (maxDays < minDays) maxDays = minDays;

      var today = new Date();
      var minDate = addBusinessDays(today, minDays);
      var maxDate = addBusinessDays(today, maxDays);
      textEl.textContent = minDays === maxDays
        ? prefix + ' ' + formatDate(minDate)
        : prefix + ' ' + formatDate(minDate) + ' - ' + formatDate(maxDate);
    })();

    function bindFeaturedQuickBuy() {
      root.querySelectorAll('[data-sf-fqb-open]').forEach(function (btn) {
        if (btn.__sfFqbBound) return;
        btn.__sfFqbBound = true;
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var card = btn.closest('.sf-fqb');
          if (!card) return;
          var source = card.querySelector('[data-sf-pcard]');
          if (!source) return;
          try {
            if (window.SFQuickBuy && typeof window.SFQuickBuy.openFromCard === 'function') {
              window.SFQuickBuy.openFromCard(source);
              return;
            }
          } catch (err) {}
          var fallbackUrl = source.getAttribute('data-product-url') || '';
          if (fallbackUrl) window.location.href = fallbackUrl;
        });
      });
    }

    (function setupZoomTiles() {
      function ensureCursor(tile) {
        var cursor = tile.querySelector('.sf-cursor');
        if (cursor) return cursor;
        cursor = document.createElement('div');
        cursor.className = 'sf-cursor';
        cursor.setAttribute('aria-hidden', 'true');
        cursor.innerHTML =
          '<svg class="sf-cur-plus" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M11 5v6H5v2h6v6h2v-6h6v-2h-6V5z"/></svg>' +
          '<svg class="sf-cur-minus" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M5 11h14v2H5z"/></svg>';
        tile.appendChild(cursor);
        return cursor;
      }

      root.querySelectorAll('[data-sf-zoom-tile]').forEach(function (tile) {
        if (tile.__sfZoomInit || tile.classList.contains('has-video')) return;
        tile.__sfZoomInit = true;

        var cursor = ensureCursor(tile);
        var isZoomed = false;
        var raf = 0;
        var lastX = 0.5;
        var lastY = 0.5;

        function scaleValue() {
          return parseFloat(getComputedStyle(root).getPropertyValue('--sf-zoom-scale')) || 2;
        }

        function setTransform(xPct, yPct) {
          var r = tile.getBoundingClientRect();
          var scale = scaleValue();
          var extraX = Math.max(0, (scale - 1) * r.width);
          var extraY = Math.max(0, (scale - 1) * r.height);
          var maxX = extraX / 2;
          var maxY = extraY / 2;
          var panX = (0.5 - xPct) * 2 * maxX;
          var panY = (0.5 - yPct) * 2 * maxY;
          tile.style.setProperty('--sf-scale', isZoomed ? String(scale) : '1');
          tile.style.setProperty('--sf-pan-x', isZoomed ? panX.toFixed(2) + 'px' : '0px');
          tile.style.setProperty('--sf-pan-y', isZoomed ? panY.toFixed(2) + 'px' : '0px');
        }

        function toggleZoom() {
          isZoomed = !isZoomed;
          tile.classList.toggle('is-zoomed', isZoomed);
          if (!isZoomed) {
            tile.style.setProperty('--sf-scale', '1');
            tile.style.setProperty('--sf-pan-x', '0px');
            tile.style.setProperty('--sf-pan-y', '0px');
          } else {
            setTransform(lastX, lastY);
          }
        }

        function setCursorPos(e) {
          var r = tile.getBoundingClientRect();
          var x = e.clientX - r.left;
          var y = e.clientY - r.top;
          cursor.style.left = x + 'px';
          cursor.style.top = y + 'px';
          if (!isZoomed) return;
          lastX = Math.max(0, Math.min(1, x / Math.max(1, r.width)));
          lastY = Math.max(0, Math.min(1, y / Math.max(1, r.height)));
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = 0;
            setTransform(lastX, lastY);
          });
        }

        tile.addEventListener('click', function (e) {
          if (e.target.closest('[data-sf-video-toggle]')) return;
          toggleZoom();
        });
        tile.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleZoom();
          }
        });
        tile.addEventListener('mousemove', setCursorPos);
        tile.addEventListener('mouseenter', setCursorPos);
        tile.addEventListener('touchstart', function () {
          if (isZoomed) setTransform(0.5, 0.5);
        }, { passive: true });
      });
    })();

    if (root.getAttribute('data-sf-enable-free-pair') !== 'true') {
      updateDisabledStates();
      setPressedState();
      onAnyChange();
    }

bindFeaturedQuickBuy();

window.requestAnimationFrame(function () {
  window.setTimeout(function () {
    window.clearTimeout(sfRevealFallbackTimer);
    revealSfPdpRoot(root);
  }, 80);
});
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sf-pdp-root]').forEach(initRoot);
    cleanLooxLabels(scope || document);
formatRelatedLooxLabels(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
